import React, { useState } from "react";
import { Formik } from "formik";
import { toast } from "react-hot-toast";
import Textbox from "../components/Textbox";
import loginimage from "../assets/images/jonathan-borba-uB7q7aipU2o-unsplash.jpg";
import { getShopLogin } from "./../services/shop.service";

interface LoginModel {
  username: string;
  password: string;
  email?: string;
}
const initialState: LoginModel = {
  username: "",
  password: "",
};

const validation = (values: LoginModel) => {
  const errors: any = {};

  if (!values.username) {
    errors.username = "User Name is required.";
  } else if (values.username.length > 50) {
    errors.username = "User Name length should be less than 50 char";
  }
  if (!values.password) {
    errors.password = "Password is required.";
  }
  return errors;
};

const Login = (props: any) => {
  const [state, setState] = useState(initialState);
  const handleStepSubmit = async (data: LoginModel) => {
    await getShopLogin({ username: data?.username, password: data?.password })
      .then((res) => {
        if (res?.statusCode === 200 || res?.data) {
          toast.success("Login Successfully");
          console.log(res.data.token);
          localStorage.setItem("token", "Admin");
          localStorage.setItem("login_token", res.data.token);
          props.history.push("/shop");
        } else {
          toast.error("Username or Password incorrect Please try again!");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <>
      <Formik
        onSubmit={(values) => handleStepSubmit(values)}
        enableReinitialize={true}
        initialValues={initialState}
        validate={(values) => {
          return validation(values);
        }}
      >
        {({
          handleSubmit,
          values,
          handleChange,
          errors,
          setFieldValue,
          touched,
        }) => (
          <>
            {console.log("errors", errors)}
            <section className="vh-500">
              <div className="container py-8 h-100">
                <div className="row d-flex justify-content-center align-items-center h-100">
                  <div className="col col-xl-10">
                    <div className="card" style={{ borderRadius: "1rem" }}>
                      <div className="row g-0">
                        <div className="col-md-6 col-lg-5 d-none d-md-block">
                          <img
                            src={loginimage}
                            alt="login form"
                            className="img-fluid"
                            style={{ borderRadius: "1rem 0 0 1rem" }}
                          />
                        </div>
                        <div className="col-md-6 col-lg-7 d-flex align-items-center">
                          <div className="card-body p-4 p-lg-5 text-black">
                            <form onSubmit={handleSubmit}>
                              <div className="d-flex align-items-center mb-3 pb-1">
                                <i
                                  className="fas fa-cubes fa-2x me-3"
                                  style={{ color: "#ff6219" }}
                                ></i>
                                <span className="h1 fw-bold mb-0">
                                  ServoFeat
                                </span>
                              </div>
                              <h5
                                className="fw-normal mb-3 pb-3"
                                style={{ letterSpacing: "1px" }}
                              >
                                Sign into your account
                              </h5>
                              <div className="form-outline mb-4">
                                <Textbox
                                  name="username"
                                  placeholder="Enter your UserName here"
                                  value={values.username}
                                  onChange={handleChange}
                                  label="UserName"
                                  errorMessage={
                                    touched.username ? errors.username : ""
                                  }
                                />
                              </div>
                              <div className="form-outline mb-4">
                                <Textbox
                                  name="password"
                                  type="password"
                                  placeholder="Enter your Password here"
                                  value={values.password}
                                  onChange={handleChange}
                                  label="Password"
                                  maxLength={10}
                                  errorMessage={
                                    touched.password ? errors.password : ""
                                  }
                                />
                              </div>

                              <div className="pt-1 mb-4">
                                <button
                                  className="btn btn-dark btn-lg btn-block"
                                  type="submit"
                                >
                                  Login
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}
      </Formik>
    </>
  );
};

export default Login;
